import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

class VideoPlayer extends React.Component {
  componentDidMount() {
    // instantiate video.js
    this.player = videojs(this.videoNode, this.props)
  }

  componentWillUnmount() {
    // destroy player on unmount
    if (this.player) {
      this.player.dispose();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // 선택한 영상이 바뀌면 영상 플레이어 url을 바꿔줌
    if(prevProps.currentIndex !== this.props.currentIndex) {
      this.player.src(this.props.sources[this.props.currentIndex]);
    }
  }

  render() {
    return (
      <div data-vjs-player>
        <video ref={node => (this.videoNode = node)} className="video-js vjs-big-play-centered" />
      </div>
    );
  }
}

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/VideoPlayer.js